import { render, staticRenderFns } from "./InputfieldText.vue?vue&type=template&id=68070a38&scoped=true&"
import script from "./InputfieldText.vue?vue&type=script&lang=js&"
export * from "./InputfieldText.vue?vue&type=script&lang=js&"
import style0 from "./InputfieldText.vue?vue&type=style&index=0&id=68070a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68070a38",
  null
  
)

export default component.exports